import React, { useEffect, useState } from 'react';
import { useCustomers } from '../context/CustomersContext'; // Ensure the correct path

const CompanyJobsiteSelector = ({ onCompanySelect, onJobsiteSelect }) => {
  const { customers, loading, error } = useCustomers();
  const [selectedCompany, setSelectedCompany] = useState('');
  const [companyJobsites, setCompanyJobsites] = useState([]);

  // Remove duplicate companies
  const uniqueCompanies = Array.from(
    new Map(customers.map((customer) => [customer.companyName, customer])).values()
  );

  // Handle company selection
  const handleCompanyChange = (e) => {
    const companyName = e.target.value;
    setSelectedCompany(companyName);
    onCompanySelect(companyName); // Pass selected company to the parent

    // Filter jobsites by selected company name
    const filteredJobsites = customers.filter(
      (customer) => customer.companyName === companyName
    );
    setCompanyJobsites(filteredJobsites);
  };

  // Handle jobsite selection
  const handleJobsiteChange = (e) => {
    const selectedCode = e.target.value;
    const selectedJobsite = companyJobsites.find(
      (jobsite) => jobsite.code === selectedCode
    );
    onJobsiteSelect(selectedJobsite.jobsite); // Pass selected jobsite to the parent
  };

  return (
    <div className="w-full mx-auto space-y-4">
      {loading ? (
        <p>Loading customers...</p>
      ) : error ? (
        <p>Error: {error}</p>
      ) : (
        <>
          {/* Company Selector */}
          <select
            id="company"
            value={selectedCompany}
            onChange={handleCompanyChange}
            className="w-full border rounded-lg bg-transparent border-gray-700 p-5 outline-none"
          >
            <option value="">Select a Company</option>
            {uniqueCompanies.map((customer) => (
              <option key={customer.companyName} value={customer.companyName}>
                {customer.companyName.toUpperCase()}
              </option>
            ))}
          </select>

          {/* Display jobsites for the selected company */}
          {selectedCompany && (
            <div>
              {companyJobsites.length > 0 ? (
                <div>
                  <select
                    id="jobsite"
                    className="w-full border rounded-lg bg-transparent border-gray-700 p-5 outline-none"
                    onChange={handleJobsiteChange}
                  >
                    <option value="">Select a Jobsite</option>
                    {companyJobsites.map((jobsite) => (
                      <option key={jobsite.id} value={jobsite.code}>
                        {jobsite.jobsite}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <p>No jobsites found for this company.</p>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CompanyJobsiteSelector;
